import PrizeDraw from './PrizeDraw';
export default PrizeDraw;
